// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1295":"a00d263e","2088":"a00d263e","2911":"2f8602c4"}[chunkId] + ".chunk.css";
};